import { render, staticRenderFns } from "./ManualShortlistModal.vue?vue&type=template&id=25ff04fc"
import script from "./ManualShortlistModal.vue?vue&type=script&lang=js"
export * from "./ManualShortlistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports